import { useComponentTheme } from "@ui-kit/components"
import { Nullable, useLocaleStore } from "@versatile-credit-apply/sdk"
import { useGroupId } from "@versatile-credit-apply/composition"
import { onMounted, watch } from "vue"

export const useGroupComponentsTheme = () => {
  const store = useLocaleStore()
  const group = useGroupId()
  const theme = useComponentTheme()

  const changeTheme = (newTheme: Nullable<string>) => {
    const id = newTheme ?? "versatile"
    theme.value = {
      id,
    }

    store.theme = id
  }

  watch(group, changeTheme)
  onMounted(() => changeTheme(group.value))
}
